import { Component, OnInit } from '@angular/core';
import { GlobalWatchService } from 'src/app/shared/services/global-watch.service';
import { StorageService } from 'src/app/shared/services/storage.service';

@Component({
	selector: 'app-cookie-banner',
	templateUrl: './cookie-banner.component.html'
})
export class CookieBannerComponent implements OnInit {

	public hasCookie: boolean = false;

	public isBlacklisted: boolean = false;

	constructor(
		private _globalWatchService: GlobalWatchService,
		private _storageService: StorageService
	) { }

	ngOnInit(): void {
		//console.log('CookieBannerComponent.ngOnInit');
		this.hasCookie = this._storageService.getCookieBanner();
		//console.log('CookieBannerComponent.hasCookie:', this.hasCookie);

		//this.checkUrls ();
	}


	//this wasn't updating with page change. need to hook into this at the app level
	// public checkUrls () {
	// 	const curHref = window.location.href,
	// 		curPath = window.location.pathname;
	// 	console.log('checkUrls.curHref:', curHref);
	// 	console.log('checkUrls.curPath:', curPath);
			
	// }


	public closeCookieBanner() {
		//console.log('CookieBannerComponent.closeCookieBanner');
		this.hasCookie = true;
		this._storageService.setCookieBanner(true);
		this._globalWatchService.setHasCookie(true);
	}

}
